import React, { Component } from 'react';
import { appImgAlt, domainUrl, routeAfterLogin } from '../config/Config';
import { UserId } from '../helpers/User';
import { getUserData, setUserData, reactLoader, getTokenData, parseJwt, message } from '../helpers/Common';
import { runValidation } from '../helpers/Validation';
import Footer from '../partials/Footer';

// Assign $ value to use jquery
const $ = window.$;

export default class ChatRate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: getUserData("appFullDate", true),
            selectedIndex: 0,
            dlrList: []
        };
    }
    getDlrList() {
        reactLoader("show", "Please wait...");
        fetch(domainUrl + "user/get-dlr-list", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                user_id: UserId()
            })
        }).then((response) => response.json()).then((responseJson) => {
            reactLoader("hide");
            if (responseJson.status !== 0) {
                this.setState({
                    dlrList: responseJson.data
                });
                setTimeout(() => {
                    this.initFlexSlider();
                }, 600)
            }
        });
    }
    componentWillMount() {
        this.getDlrList();
    }
    componentDidMount() {
        document.body.className = "inner dlrpage";
    }
    initFlexSlider() {
        $('.flexslider').flexslider({
            animation: "slide",
            start: function (slider) {
                $('body').removeClass('loading');
            }
        })
    }
    navigateUser(statusMsg) {
        let userData = parseJwt(getTokenData());
        if (userData.afterRoutes.length > 1) {
            userData.afterRoutes.splice(0, 1);
            setUserData("afterRoutes", userData.afterRoutes, true);
            setTimeout(() => {
                reactLoader("hide");
                this.redirectWithMsg(statusMsg, userData.afterRoutes[0].url);
            }, 1200);
        } else {
            setUserData("globalAccess", true, true);
            setTimeout(() => {
                setUserData("afterRoutes", [], true);
            }, 500);
            setTimeout(() => {
                reactLoader("hide");
                this.redirectWithMsg(statusMsg, routeAfterLogin);
            }, 1200);
        }
    }
    redirectWithMsg(statusMsg, url) {
        window.swal("", statusMsg).then((value) => {
            this.props.router.push(url);
        });
    }
    changeID(index, dlrId) {
        $('input[name="' + dlrId + '_hidden"]').val(index);
        this.setState({
            selectedIndex: index
        })
    }
    noThanks(dlrId) {
        reactLoader("show");
        fetch(domainUrl + "user/schedule/dlr", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getTokenData()
            },
            body: JSON.stringify({
                dlr_id: dlrId,
                user_id: UserId(),
                type: 'cancel'
            })
        }).then((response) => response.json()).then((responseJson) => {
            let statusMsg = (responseJson.status === 0) ? responseJson.errors : responseJson.message;
            this.navigateUser(statusMsg);
        });
    }
    bookNow(dlrId) {
        if (runValidation('dlr_' + dlrId)) {
            reactLoader("show");
            fetch(domainUrl + "user/schedule/dlr", {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + getTokenData()
                },
                body: JSON.stringify({
                    dlr_id: dlrId,
                    user_id: UserId(),
                    schedule_id: $('input[name="' + dlrId + '_hidden"]').val(),
                    type: 'book'
                })
            }).then((response) => response.json()).then((responseJson) => {
                let statusMsg = (responseJson.status === 0) ? responseJson.errors : responseJson.message;
                this.navigateUser(statusMsg);
            });
        }
    }
    render() {
        const dlrHtml = this.state.dlrList.map((val, key) => {
            return <li key={`dlr_${key}`}>
                <div>
                    <h2>{val.slug} . {val.name}</h2>
                    <div className="videoicon"><img src={process.env.PUBLIC_URL + '/images/video-icon.png'} alt="" title="" /></div>
                    <div className="video-sessions">
                        <ul>
                            {
                                val.schedule.map((scheduleVal, scheduleKey) => {
                                    return <li key={`schedule_${val.id}_${scheduleKey}`}>
                                        <input type="radio" value={scheduleVal.id} checked={this.state.selectedIndex === scheduleVal.id} onChange={() => this.changeID(scheduleVal.id, val.id)} />
                                        {scheduleVal.date}, {scheduleVal.from} to {scheduleVal.to}
                                    </li>
                                })
                            }
                            <li><input type="hidden" name={`${val.id}_hidden`} className={`required dlr_${val.id}`} /></li>
                        </ul>
                    </div>
                    <div className="sechd-btn" id="btn_book">
                        <input type="submit" className="btn_name" value="Book" onClick={(e) => this.bookNow(val.id)} />
                        <input type="button" className="btn_name" value="No thanks" onClick={(e) => this.noThanks(val.id)} />
                    </div>
                </div>
            </li>
        });
        return (<div className="row">
            <header>
                <div className="logo"><img src={process.env.PUBLIC_URL + '/images/logo.png'} alt="" title={appImgAlt} border="0" /></div>
                <div className="top-links"><img src={process.env.PUBLIC_URL + '/images/calendar_icon.png'} alt="" title="" border="0" />{this.state.date}</div>
            </header>
            <section className="maincontent">
                <section className="content">
                    <h1>Schedule your Dynamic Learning Rooms</h1>
                    <div className="gray-box dlrsechdule">
                        <div className="pin-form">
                            <h2>You have {this.state.dlrList.length} new active DLR(s).</h2>
                            <div className="sechdle-video">
                                <div className="flexslider">
                                    <ul className="slides">{dlrHtml}</ul>
                                </div>
                            </div>
                            <span><strong>Note:</strong> For good quality viewing of the Live session, we recommend internet speed of 1 MBPS</span>
                        </div>
                        <div className="img-box"><img src={process.env.PUBLIC_URL + '/images/schedule-img.jpg'} alt="" title="" /></div>
                    </div>
                </section>
            </section>
            <Footer />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/pages/ScheduleDlr.js